function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dashboard"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-.986 2.067c.036.52.457.933.986.933s.95-.413.986-.933c3.623.448 6.498 3.323 6.946 6.946-.519.037-.932.458-.932.987s.413.95.933.986c-.087.703-.264 1.379-.521 2.014h-4.412c0-1.302-.839-2.401-2-2.815v-3.185c0-.553-.447-1-1-1s-1 .447-1 1v3.185c-1.161.414-2 1.513-2 2.815h-4.411c-.258-.635-.435-1.311-.521-2.014.519-.036.932-.457.932-.986s-.413-.95-.933-.986c.449-3.623 3.324-6.498 6.947-6.947zm.986 9.933c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm0 6c-2.52 0-4.768-1.174-6.235-3h4.015c.55.609 1.337 1 2.22 1s1.67-.391 2.22-1h4.016c-1.468 1.826-3.716 3-6.236 3z"
}));

var Svg038Dashboard = function Svg038Dashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg038Dashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/038-dashboard.598ddb20.svg";
export { ForwardRef as ReactComponent };